var xhr, scheduled = false, _throttleDelay = 200, $body, $modal, $secondaryModal,$window;
var timeout = false;
var delta = 200;
var subnavOrigin = 0;
var body = document.querySelector("body");
var $header;
var $header_is_fixed = false;  


$(function(){	
	"use strict";
    $body   =  $('body');
    $window = $(window);
    $header = $('header');
    

    if ("ontouchstart" in window || navigator.msMaxTouchPoints) {
        $body.addClass('touch');
    } else {
        $body.addClass('no-touch');    
        if($('.skrollr').length>0){
            var s = skrollr.init();    
        } 
    }

    $body.addClass('loaded');
    $('.burder').click(function(){
        if($body.hasClass('menu-open')){
            $body.removeClass('menu-open');
            $('.nav-scroller').removeClass('nav-scrolled');     
            $('.nav-scroller').animate({ scrollTop: 0 }, 300);
        }else{
            $body.addClass('menu-open');
        }
        return false;
    });


    initWayPoints();


    if( $('.way-point-squares').length>0 ){
        $('.way-point-squares').waypoint(function(direction) {
            if(  $(this.element).hasClass('squares_shown')  ) {
                 $(this.element).removeClass('squares_shown') ;
            }else{
                 $(this.element).addClass('squares_shown');
            }
            }, {
            offset: '95%'
        });
        $('.way-point-squares').waypoint(function(direction) {
            if(  $(this.element).hasClass('squares_shown')  ) {
                 $(this.element).removeClass('squares_shown') ;
            }else{
                 $(this.element).addClass('squares_shown');
            }
          }, {
            offset: '-10%'
        });
    }

    
    $.cookieBar({
        element: 'body',
        zindex: '999999',
        fixed: true,
        message: '<div class="cookies-notification__text mobile-pr0"><div class="font-bold title-16">COOKIE POLICY</div><p>La Tour Melas uses cookies to make our site easier for you to use. We also share that information with third parties for analytics. For more info visit our <a href="'+COOKIE_URL+'">Legal information</a>.</p></div>',
        acceptText: '<span class="over">I AGREE</span>',
        policyText: '<span class="hover--white a-center clickable trans display--block" id="cookieBar_close">Close<svg viewBox="0 0 77.47 77.47" id="close"><path class="path trans" d="M77.474 5.011L72.463 0 38.737 33.727 5.011 0 0 5.011l33.727 33.726L0 72.463l5.011 5.011 33.726-33.726 33.726 33.726 5.011-5.011-33.726-33.726z"></path></svg></span>',
        policyURL:'#',
        policyButton:false,
        bottom: true,
        domain: 'www.latourmelas.com',
        referrer: 'www.latourmelas.com'
    });
   
    $(".fancybox").fancybox();
    
	callbacks();
	
    var keydown_timeout;    


    $(document).on('click', '.scroll-to-element',function (e) {
        scroll2element($(this).attr('href'));
        e.preventDefault();
    });

    $(document).on('click', '#cookie-bar a.cb-policy', function (e) {
        $('#cookie-bar').addClass('r-loc');
        return false;
    });

    $(document).on('click', '#cookie-bar a.cb-enable', function (e) {
        $('#cookie-bar').addClass('r-loc');
    });



    $(document).on('click', '[data-action="submit"]', function () {
        var target = $(this).data('target');
        $(target).submit();
        return false;
    });
	
    $(".footer__back-to-top").click(function(){
        $("html,body").animate({scrollTop: 0 },"1000");
        return false;
    });  

    $(document).on('click', ".modal-btn", function (e) {
        try{
            e.preventDefault();         
           if($(this).attr("href")){
                openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));             
            }else{
                openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));             
            }   
        }catch(Error){
            console.log(Error);
        }
        return false;
    });
    scrollEvents();
   
});

function initShares(){
    "use strict";
    $('#ajaxModal').on('hidden.bs.modal', function () {
        if($('#ajaxModalFull').hasClass('in')){
            $('body').addClass('modal-open');
        }
    });
    
    
    var clipboard = new Clipboard('.clipboardButton');
    clipboard.on('success', function(e) {
        console.info('Action:', e.action);
        console.info('Text:', e.text);
        console.info('Trigger:', e.trigger);
        
        $('.clipboardButton .copy-label').text(' copied!');
        
        e.clearSelection();
    });
    clipboard.on('error', function(e) {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
        
    }); 
}

function initWayPoints(){   
    var ua = navigator.userAgent.toLowerCase(); 
    if (ua.indexOf('safari') != -1) { 
      if (ua.indexOf('chrome') > -1) {
        var  $safari = false;
      } else {
        var  $safari = true;
      }
    }
    if($safari ){
        $('.way-point-animate').addClass('shown') ;
    }else{
        if( $('.way-point-animate').not( ".way-point-ready").length>0 ){
           
            $('.way-point-animate').addClass( "way-point-ready");

            if(  $('.vintages--content').not( ".way-point-ready").length>0 ){
                 $('.vintages--content').addClass( "way-point-ready");
            }

            $('.way-point-animate').waypoint(function(direction) {
                if(  $(this.element).hasClass('shown')  && $('.way-point-animate').length > 2 ) {
                         $(this.element).removeClass('shown') ;
                    }else{
                         $(this.element).addClass('shown');
                    }
                                }, {
                offset: '90%' 
            });
            $('.way-point-animate').waypoint(function(direction) {
                     if(  $(this.element).hasClass('shown')  && $('.way-point-animate').length > 2  ) {
                     $(this.element).removeClass('shown') ;
                    }else{
                         $(this.element).addClass('shown');
                    }
                               
              }, {
                offset: '-90%'
            });

              $('.vintages--content').waypoint(function(direction) {
                    if(direction =='down'){
                         $(this.element).addClass('shown');
                     }else if(direction =='up'){
                         $(this.element).removeClass('shown') ;
                     }
              }, {
                offset: '90%' 
            });

          
        } 
    }
}

function scrollEvents(){    
    "use strict";

    var scroll_from_top_offset = 10;
    var scroll_from_top = $(document).scrollTop();      
    if(scroll_from_top > scroll_from_top_offset){
        $body.addClass('scrolled');
    }else{
        $body.removeClass('scrolled');
    }
    $(window).scroll(function(){
        scroll_from_top = $(document).scrollTop();      
        if(scroll_from_top > scroll_from_top_offset){
            $body.addClass('scrolled');
        }else{
            $body.removeClass('scrolled'); 
        }
    });

    $('.nav-scroller').scroll(function(){
        scroll_from_top = $('.nav-scroller').scrollTop(); 
        if(scroll_from_top > 0){
            $('.nav-scroller').addClass('nav-scrolled');
        }else{
            $('.nav-scroller').removeClass('nav-scrolled'); 
        }
    });


      $('.modal').scroll(function(){
        if( $('.the-estate-details').length>0){
          var position = $('.the-estate-details').offset().top;
           if( position < -150){
                $('.close-fixed').addClass('scrolled');
            }else{
                 $('.close-fixed').removeClass('scrolled');
            }
        }
       
      });

    
    $(document).on('scroll', ScrollHandler);
}
function openAjaxModal(href,$mm){

    $m = $mm || $modal;


    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        callbacks('#'+$m.attr('id'));
    });

}

function equalizeHeight(target){
	$('.'+ target).each(function(){
		$('.'+ target).addClass('autoHeight');
		$('.'+ target).css('min-height','auto');
		if($('.'+ target).parent().hasClass('card')){
			$('.'+ target).css('height','auto');
		}
	});
	
    var min_height = 0;
    setTimeout(function(){
        $('.'+ target).each(function(){
            if($(this).innerHeight() > min_height){
                min_height = $(this).innerHeight();
            }
        });
        if(min_height>0){
            $('.'+ target).css('min-height',min_height);
			if($('.'+ target).parent().hasClass('card')){
				$('.'+ target).css('height',min_height);
			}
        }
		$('.'+ target).each(function(){			 
			$('.'+ target).removeClass('autoHeight');
		});
		
    },500);
	
}


function form_submit_response(target, type, message, r) {
    "use strict";
    var redirect = r || false;
    //alert(message);
    
    
    var $timeout = 0;
    
    if($body.hasClass('modal-open') ){
        $('.modal').modal('hide');
        $timeout = 300; 
    }
    setTimeout(function(){
        var _container = target || '';
        if(type == 'success'){
            var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>'; 
        }else{
            var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';   
        }
        var content = '<div class="alert alert-'+type+'"><span>'+icon+' '+message+'</span></div>'
        $('#responseModal .modal-body').html(content);  
        $body.addClass('dark-backdrop');
        $('#responseModal').modal('show');
        $('#responseModal').on('hidden.bs.modal', function () {
            $('#responseModal .modal-body').empty();
            $body.removeClass('dark-backdrop');
        });
    },$timeout);
    
    setTimeout(function(){
        $('#responseModal').modal('hide');
    },3000);
    
    
    if (redirect) {
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }
}




function triggerClick(target) {
	$('.'+target).trigger('click');
}

function callbacks(c) {
    var container = c || '';
    ajaxContent(container + ' .ajax-content');
    initWayPoints();
    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
            var c = $(this).data();
            for (var i in c) {
                if (i.indexOf('fn') == 0 && c[i] != '') {
                    var fn = c[i];
                    var params = c[ 'params' + i ] || null;

                    $(this).addClass('callbacks-executed');

                    try {
                        if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                            var callbackAfter = c[ 'after' + i ];
                            var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                            window[ fn ](params, function(){
                                window[callbackAfter](callbackAfterParams);
                            });
                        } else {
                            window[ fn ](params);
                        }
                    } catch (Error) {
                        console.log(Error + ' '+fn);
                    }
                }
            }
        }
        }
    });
}
function ScrollHandler(e) {
    
}

function scroll2position(pos,t) {
    var el = $(pos);
    $('html, body').animate({scrollTop:  el.innerHeight() }, t || 500);
   return false;
}


function more(target) {
    if ($('form[name="' + target + '-nav"] ').hasClass('busy')) {
        return false;
    }

    var c = $('form[name="' + target + '-nav"] input[name="page"]').val();
    var offset = $('form[name="' + target + '-nav"] input[name="offset"]').val();
    $('form[name="' + target + '-nav"] input[name="page"]').val(Number(c) + 1);
    $('form[name="' + target + '-nav"]').addClass('busy');
    $('.load-more[data-target="'+target+'"]').hide();
    $.ajax({data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html', success: function (result) {
        $('form[name="' + target + '-nav"]').removeClass('busy');

        var $result = $('<div>' + result + '</div>');

        var num_items = $result.find('.item').length;
        if ( num_items > 0) {
            $result.find('.item').hide();
            $('.' + target + '-list').append($result.html());
            $('.' + target + '-list .item').fadeIn('fast');

            callbacks('.' + target + '-list');

            $('.load-more[data-target="'+target+'"]').show();
            if(num_items<offset){
                $(document).off('scroll', ScrollHandler);
            }
        } else {
            $('.load-more[data-target="'+target+'"]').hide();
            $(document).off('scroll', ScrollHandler);
        }

        $('.' + target + '-list .way-point-animate').waypoint(function(direction) {
            $(this.element).addClass('shown');
        }, {
            offset: '95%'
        });

        if($('.' + target + '-list').data('afterFilter')){
            window[$('.' + target + '-list').data('afterFilter')]($('.' + target + '-list').data('afterFilterParams'));
        }
    }
    });
}

var ajax_contents = [];
function ajaxContent(c){
    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'target': $(this),
                'content':$(this).data('ajaxContent')
            }
        );
    });
    loadAjaxContent();
}

function loadAjaxContent(){
    if(ajax_contents.length > 0){
        var target  = ajax_contents[0].target,
            content = ajax_contents[0].content;

        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');
            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}

